import dayjs from 'dayjs';
import { summaryTitleFor } from 'shared/checkin-weeks';

type LabelItem = {
  kind: 'standup' | 'summary';
  date: string;
  submittedAt: Date;
  isSprint?: boolean;
};

/** "Tuesday standup, Nov 10", "Weekly summary, week 1" or "Sprint summary". */
export function checkinItemTitle(item: LabelItem, startDate?: string) {
  if (item.kind === 'summary' && item.isSprint) {
    return 'Sprint summary';
  }
  if (item.kind === 'summary') {
    return summaryTitleFor(item.date, { startDate, sprintSummary: false });
  }
  return `${dayjs(item.date).format('dddd')} standup, ${dayjs(item.date).format('MMM D')}`;
}

/**
 * When it came in. A standup posted on its own day shows just the time; a
 * catch-up standup shows the day it actually arrived.
 */
export function submittedLabel(item: LabelItem) {
  const at = dayjs(item.submittedAt);
  const verb = item.kind === 'summary' ? 'Sent' : 'Posted';
  if (item.kind === 'standup' && at.format('YYYY-MM-DD') === item.date) {
    return `${verb} ${at.format('h:mm A')}`;
  }
  return `${verb} ${at.format('ddd, MMM D, h:mm A')}`;
}
